import { ApiGetRequest } from './api-get-request';

export class PayMethodsRequest extends ApiGetRequest
{
    constructor(webapiBasepath: string)
    {
        super('paymethod/shopflow', null, null, webapiBasepath);
    }
}
